module.exports = __webpack_public_path__ + "img/img-2.2157d9fd.svg";